import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { UserPlus } from 'lucide-react';

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await register(formData);
    setLoading(false);
    if (success) {
      navigate('/account');
    }
  };

  return (
    <div className="bg-off_white min-h-screen flex items-center justify-center py-12" data-testid="register-page">
      <div className="max-w-md w-full mx-auto px-4">
        <div className="bg-white border-4 border-black rounded-2xl p-8 shadow-hard-lg">
          <div className="text-center mb-8">
            <div className="bg-brand_yellow w-20 h-20 rounded-full border-4 border-black mx-auto mb-4 flex items-center justify-center">
              <UserPlus className="w-10 h-10" strokeWidth={3} />
            </div>
            <h1 className="font-chewy text-4xl text-brand_blue mb-2">Create Account</h1>
            <p className="font-nunito text-gray-600 font-semibold">Join the Uncle Dave's family!</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="font-nunito font-bold block mb-2">Full Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-name"
                placeholder="John Doe"
              />
            </div>

            <div>
              <label className="font-nunito font-bold block mb-2">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-email"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="font-nunito font-bold block mb-2">Phone (optional)</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-phone"
                placeholder="(555) 123-4567"
              />
            </div>

            <div>
              <label className="font-nunito font-bold block mb-2">Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                minLength="6"
                className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                data-testid="input-password"
                placeholder="••••••••"
              />
              <p className="font-nunito text-xs text-gray-600 mt-1">Minimum 6 characters</p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand_blue text-white font-chewy text-xl px-8 py-4 rounded-full border-4 border-black shadow-hard-lg hover:shadow-hard-hover hover:-translate-y-1 transition-all disabled:opacity-50"
              data-testid="register-button"
            >
              {loading ? 'CREATING ACCOUNT...' : 'CREATE ACCOUNT'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="font-nunito font-semibold">
              Already have an account?{' '}
              <Link to="/login" className="text-brand_blue font-bold hover:text-brand_red" data-testid="login-link">
                Login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;